import { render, staticRenderFns } from "./details1.vue?vue&type=template&id=5707b978&scoped=true&"
import script from "./details1.vue?vue&type=script&lang=js&"
export * from "./details1.vue?vue&type=script&lang=js&"
import style0 from "./details1.vue?vue&type=style&index=0&id=5707b978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707b978",
  null
  
)

export default component.exports